module.exports = __webpack_public_path__ + "6036fdfd06d74af3eb8e903a857361d7.pdf";